module.exports = __webpack_public_path__ + "static/img/glovis-aa.49cc876.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/glovis-aa.jpg
// module id = EVEh
// module chunks = 0